export type InfotipState = object;
export const initialState: InfotipState = {};
